import { gql } from "@apollo/client";

const GET_CHALLENGE_TYPES = gql`
  query GetChallengeTypes($filters: TagFilter) {
    challengeTypes(filters: $filters) {
      nodes {
        name
        id
        uuid
      }
    }
  }
`;

export { GET_CHALLENGE_TYPES };
